import {createRouter, createWebHashHistory} from 'vue-router'

//创建路由表
import JobList from "@/pages/JobList";
import JobInfo from "@/pages/JobInfo";
import HomePage from "@/pages/HomePage";
import ResumeForm from "@/pages/ResumeForm";
import ResumeList from "@/pages/ResumeList";
import UserList from "@/pages/UserList";
import ResumeInfo from "@/pages/ResumeInfo";
import UserAcceptList from "@/pages/UserAcceptList";
import ResumeAcceptInfo from "@/pages/ResumeAcceptInfo";
import UserPassList from "@/pages/UserPassList";
import ResumePassInfo from "@/pages/ResumePassInfo";
import SystemConfig from "@/pages/SystemConfig";
import JobUpload from "@/pages/JobUpload";
import JobManageList from "@/pages/JobManageList";
import JobForm from "@/pages/JobForm";
import UserManageList from "@/pages/UserManageList";
import ManagerForm from "@/pages/ManagerForm";
import DataBoard from "@/pages/DataBoard";

const routes = [
    { path: "/", name: "Index", component: JobList,
        meta: {
            keepAlive: true,
        },
    },
    { path: "/JobList", name: "JobList", component: JobList,
        meta: {
            keepAlive: true,
        },
    },
    { path: "/JobInfo/:jobId", name: "JobInfo", component: JobInfo,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/HomePage", name: "HomePage", component: HomePage,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/ResumeForm", name: "ResumeForm", component: ResumeForm,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/ResumeList/:userId", name: "ResumeList", component: ResumeList,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/UserList", name: "UserList", component: UserList,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/ResumeInfo/:resumeId", name: "ResumeInfo", component: ResumeInfo,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/UserAcceptList", name: "UserAcceptList", component: UserAcceptList,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/ResumeAcceptInfo/:resumeId", name: "ResumeAcceptInfo", component: ResumeAcceptInfo,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/UserPassList", name: "UserPassList", component: UserPassList,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/ResumePassInfo/:resumeId", name: "ResumePassInfo", component: ResumePassInfo,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/SystemConfig", name: "SystemConfig", component: SystemConfig,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/JobUpload", name: "JobUpload", component: JobUpload,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/JobManageList", name: "JobManageList", component: JobManageList,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/JobForm/:jobId", name: "JobForm", component: JobForm,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/UserManageList", name: "UserManageList", component: UserManageList,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/ManagerForm", name: "ManagerForm", component: ManagerForm,
        meta: {
            keepAlive: false,
        },
    },
    { path: "/DataBoard", name: "DataBoard", component: DataBoard,
        meta: {
            keepAlive: false,
        },
    },
]

//创建路由
const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router;